import { render, staticRenderFns } from "./VerifyEmailPage.vue?vue&type=template&id=b8edfe7c&"
import script from "./VerifyEmailPage.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailPage.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports